import React from 'react';
import { InlinePromoUiModuleBody } from '../../../../../API';
import Localized from '../../../../shared/Localized';
import { InlinePromoPreview } from '../../ContentPreview/InlinePromoPreview';
import UIModuleListItem, { IBaseUIModuleListItemProps } from '../../UIModuleListItem';
import { inlinePromoListItemTestIds } from '../../../../shared/TestsIds';

export type InlinePromoListItemProps = IBaseUIModuleListItemProps<InlinePromoUiModuleBody>;

const InlinePromoListItem = ({ uiModule, ...props }: InlinePromoListItemProps): JSX.Element => {
  return (
    <UIModuleListItem
      uiModule={uiModule}
      topLineTitle={<Localized prop={uiModule.title} />}
      renderPreview={(showPreview) => (
        <div data-testid={inlinePromoListItemTestIds.preview}>
          <InlinePromoPreview showing={showPreview} module={uiModule} />
        </div>
      )}
      {...props}
    />
  );
};

export default InlinePromoListItem;
